// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { Paper, Title } from '@mantine/core';
import type { Patient } from '@medplum/fhirtypes';
import type { JSX } from 'react';
import classes from './WelcomeHero.module.css';

interface WelcomeHeroProps {
  patient: Patient | undefined;
}

function getFirstName(patient: Patient | undefined): string {
  const given = patient?.name?.[0]?.given?.[0];
  return given && given.trim().length > 0 ? given : 'there';
}

/**
 * The maroon hero strip that greets the patient by first name. Mirrors the
 * provider dashboard's "Dashboard" hero in shape but is patient-specific in
 * copy.
 */
export function WelcomeHero({ patient }: WelcomeHeroProps): JSX.Element {
  return (
    <Paper className={classes.hero} radius="md">
      <Title order={2} c="white">
        Welcome Back, {getFirstName(patient)}
      </Title>
    </Paper>
  );
}
